import styled from 'styled-components'

export default styled.footer`
  width: 100%;
  color: ${ ({ theme }) => theme.colors.white };

  .contact {
    display: flex;
    flex-direction: row;
    gap: 48px;
    padding: 64px max(24px, calc((100% - 936px) / 2));
    background-color: ${ ({ theme }) => theme.colors.landingPrimaryDark };
  }

  h2 {
    flex: 1 1 0;
    margin: 0;
    font-size: 48px;
    font-weight: bold;
    line-height: 1.1;
  }

  .details {
    flex: 1 1 0;
    min-width: 0;
  }

  h3 {
    margin: 8px 0 24px;
    font-size: 18px;
    font-weight: bold;
  }

  address {
    font-style: normal;
    font-size: 14px;
    line-height: 1.7;
  }

  address p {
    margin: 0 0 16px;
  }

  .address span {
    display: block;
  }

  a {
    color: inherit;
    text-decoration: underline;
    word-break: break-word;

    &:focus-visible {
      outline: 2px solid ${ ({ theme }) => theme.colors.white };
      outline-offset: 2px;
    }
  }

  .partners {
    padding: 40px max(24px, calc((100% - 936px) / 2));
    background-color: ${ ({ theme }) => theme.colors.landingDark };
  }

  .partners ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 24px;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .partners li {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 180px;
    height: 76px;
    padding: 8px 12px;
    box-sizing: border-box;
    border-radius: 6px;
    background-color: ${ ({ theme }) => theme.colors.white };
  }

  .partners img {
    max-width: 100%;
    max-height: 100%;
  }

  @media screen and (max-width: 768px) {
    .contact {
      flex-direction: column;
      gap: 24px;
      padding: 48px 16px;
    }

    h2 {
      font-size: 36px;
    }

    .partners {
      padding: 32px 16px;
    }

    .partners ul {
      justify-content: center;
    }
  }
`
